import angular from 'angular';

import application from 'application/application';

application

	.directive('ngItemChildren', ['$timeout', '$parse', ($timeout, $parse) => ({
		restrict: 'A',
		link(scope, element) {

			var checkedProp = $(element).closest('ul[ng-checklist]').attr('ng-checked-prop');

			element

				.on('change', function() {

					var

						checkbox = angular.element(this),

						checkboxScope = checkbox.scope(),

						item = $parse(checkbox.attr('ng-item'))(checkboxScope),

						children = $parse(checkbox.attr('ng-item-children'))(checkboxScope);

					if (Array.isArray(children))

						children.forEach(child => {
							if (checkedProp == 'checked' && child.idSitPesqProcUsuarioCliente !== -6) {
								child[checkedProp] = false;
							}
							else {
								child[checkedProp] = item[checkedProp];
							}
						});

					$(checkbox).closest('li').find('input[type="checkbox"]').not(element).each(function() {

						$timeout(() => angular.element(this).prop('indeterminate', false).triggerHandler('change'));

					});

					$timeout(() => scope.$apply());

				});

		}
	})]);
